__turbopack_context__.v({
  "carousel": "Carousel-module-scss-module__xD68IW__carousel",
  "container": "Carousel-module-scss-module__xD68IW__container",
  "dot": "Carousel-module-scss-module__xD68IW__dot",
  "dots": "Carousel-module-scss-module__xD68IW__dots",
  "selected": "Carousel-module-scss-module__xD68IW__selected",
  "slide": "Carousel-module-scss-module__xD68IW__slide",
});
